//ATTENTION : Ne pas importer axios (ou une autre librairie) ici, pour ne pas faire planter les Tests Unitaires.
// --> Mais bien s'assurer que la librairie nécessaire sera chargée dans le composant qui va utiliser ce service !

class TokenService {

    //Decode le token pour obtenir les infos sue le user connecté
    parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    isExpired(jwt) {
        if(jwt) {
            var expire_at = new Date(jwt.exp * 1000);
            var expired = expire_at < new Date();
            return expired;
        }
        return false
    }

    /**
     * Call WordPress API to refresh and get the user access token.
     */
    async refreshUserTokenIfExpired (vueAnsContext, axios) {

        // If the user is not logged in, he does not have an access token so return an empty string
        if (!vueAnsContext.isUserLoggedIn) {
            vueAnsContext.tokens.accessToken = '';
            vueAnsContext.tokens.refreshToken = '';
        } else {
            var jwt = this.parseJwt(vueAnsContext.tokens.accessToken);
            if(this.isExpired(jwt)) {

                const paramsGet = {
                    'accessToken': vueAnsContext.tokens.accessToken,
                    'refreshToken': vueAnsContext.tokens.refreshToken
                };

                await axios.get(
                    vueAnsContext.wordPressBaseUrl + '/wp-json/ans/user/token/check',
                    { params: paramsGet }
                ).then((response) => {
                    vueAnsContext.tokens.accessToken = response.data.accessToken;
                    vueAnsContext.tokens.refreshToken = response.data.refreshToken;
                }).catch((error) => {
                    vueAnsContext.tokens.accessToken = '';
                    vueAnsContext.tokens.refreshToken = '';

                    let message = 'Le jeton de l\'utilisateur n\'a pas pu être rafraîchi.';

                    if (error.response && error.response.data && error.response.data.message)
                        message = error.response.data.message;

                    console.log(message);
                });
            }
        }
    }

}

export default new TokenService();